const { m } = require('minthril');
const { Button } = require('../button');
const { Image } = require('../image');
const { formatMoney } = require('../../business');

function ProductCard() {
  return {
    view: ({ attrs: { product, onAdd, cartQuantity = 0, variant = 'curated' } }) => {
      const productVariant = product.variants.nodes[0];
      const price = product.priceRange.minVariantPrice;
      const cardClass = `a.product-card.product-card--${variant}`;

      return m(cardClass, {
        key: product.id,
        href: `/products/${product.handle}`
      },
      m('div.product-card__image', product.featuredImage
          ? m(Image, {
          src: product.featuredImage.url,
          alt: product.featuredImage.altText || product.title,
          loading: 'lazy'
        })
        : m('span.product-card__placeholder', 'No image')
      ),
      m('div.product-card__content',
        m('p.product-card__type', product.productType || 'Performance parts'),
        m('h2.product-card__title', product.title),
        m('p.product-card__price', formatPrice(productVariant, price)),
        variant !== 'curated' && productVariant
          ? productVariant.availableForSale
            ? m('div.product-card__purchase',
              m(Button, {
                onclick: event => {
                  event.preventDefault();
                  event.stopPropagation();
                  onAdd(productVariant.id);
                }
              }, 'Add to cart'),
              cartQuantity ? m('span.product-card__cart-quantity', `In cart (${cartQuantity})`) : null
            )
            : m('p.product-card__unavailable', 'Currently unavailable')
          : null
      ));
    }
  };
}

function formatPrice(variant, fallbackPrice) {
  const currentPrice = variant?.price || fallbackPrice;
  const compareAtPrice = variant?.compareAtPrice;

  return m('span',
    compareAtPrice ? m('s.product-card__compare-price', formatMoney(compareAtPrice.amount, compareAtPrice.currencyCode)) : null,
    formatMoney(currentPrice.amount, currentPrice.currencyCode)
  );
}

module.exports = { ProductCard };
